import { Box, Typography, useTheme } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AgGridTable from "../../../components/table/AgGridTable";
import { END_POINTS } from "../../../shared";
import axiosInstance from "../../../axios/axios";
import { useEffect, useState } from "react";
import { ICellRendererParams } from "ag-grid-community";
import LoopIcon from "@mui/icons-material/Loop";
import cisco_assets from "../../../assets/cisco-assets.svg";
import Aws_img from "../../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../../assets/baseVersion/AWS_DARK.svg"
import arista_assets from "../../../assets/arista-assets.svg";
import paloalto_assets from "../../../assets/paloalto-assets.svg";
import paloalto_dark from "../../../assets/paloalto-white.svg";
import cisco_dark from "../../../assets/cisco-white.svg";
import arista_dark from "../../../assets/arista-white.svg";
import juniperLogo from "../../../assets/juniper.svg";
import juniper_dark from "../../../assets/juniper-white.svg";
import green_shield from "../../../assets/green-shield.svg";
import red_shield from "../../../assets/red-shield.svg";
import orange_shield from "../../../assets/orange-shield.svg";
// import misconfig from "../../../assets/misconfig.svg";
import misconfig from "../../../assets/misconfig.svg";
import { useNavigate } from "react-router-dom";
import useFrameworks from "../../../shared/hooks/useFrameworks";
import LaunchSharpIcon from "@mui/icons-material/LaunchSharp";


const ResourceCount = ({ setDrawerOpen,CloudID }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const { enabledFrameworkKeys } = useFrameworks();
  console.log("CloudID in ResourceCount:", CloudID);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [isResourceRowData, setIsResourceRowData] = useState<any[]>([]);

  const ResourceColumnDefs: any = [
    {
      field: "cloud",
      headerName: "Resource Name",
      filter: false,
      sortable: false,
      minWidth: 140,
      cellRenderer: (params: ICellRendererParams) =>
        params.data.vendor.toLowerCase() === "cisco" ? (
          <img
            src={isDarkMode ? cisco_dark : cisco_assets}
            alt="Cisco"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor.toLowerCase() === "juniper" ? (
          <img
            src={isDarkMode ? juniper_dark : juniperLogo}
            alt="Juniper"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor?.toLowerCase() === "paloalto" ||
          params.data.vendor?.toLowerCase() === "palo alto" ? (
          <img
            src={isDarkMode ? paloalto_dark : paloalto_assets}
            alt="Palo Alto"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor.toLowerCase() === "arista" ? (
          <img
            src={isDarkMode ? arista_dark : arista_assets}
            alt="Arista"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.cloud.toLowerCase() === "amazon web services" ? (
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}
          >
            <img
              src={isDarkMode?AWS_DARK:Aws_img}
              alt="AWS"
              style={{ width: "20px", height: "20px" }}
            />
            <Typography
              title={params.data.resource_name}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontSize: "14px",
                fontWeight: 500,
                color: "#585874",
                ml: 1,
                maxWidth: 120,
                flex: 1,
                minWidth: 0,
                display: "block",
              }}
            >
              {params.data.resource_name}
            </Typography>
          </Box>
        ) : (
          <Typography
            title={params.data.vendor}
            sx={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {params.data.vendor}
          </Typography>
        ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        // paddingTop: "20px",
      },
    },
    {
      field: "resources_type",
      headerName: "Resource Type",
      filter: true,
      minWidth: 160,
      width: 240,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "account_id",
      headerName: "Account ID",
      minWidth: 150,
      width: 190,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      sortable: true,
    },
    // {
    //   field: "region_name",
    //   headerName: "Region",
    //   filter: true,
    //   minWidth: 150,
    //   width: 190,
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },
    {
      field: "score",
      headerName: "Score",
      filter: false,
      minWidth: 170,
      width: 200,
      cellRenderer: (params: ICellRendererParams) => {
        return params.data?.status === 3 ? (
          <Box display="flex" alignItems="center" gap={1}>
            {params.data.score <= 50 && (
              <img src={red_shield} alt="Low Security Score" />
            )}
            {params.data.score > 50 && params.data.score < 80 && (
              <img src={orange_shield} alt="Medium Security Score" />
            )}
            {params.data.score >= 80 && (
              <img src={green_shield} alt="High Security Score" />
            )}
            <Typography title={params.data.score}>
              {Math.round(params.data.score)}
            </Typography>
          </Box>
        ) : (
          <span>
            <LoopIcon sx={{ color: "text.secondary", fontSize: 16 }} />
            <span>Scanning...</span>
          </span>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "vulnerability",
      headerName: "Misconfigurations",
      minWidth: 190,
      width: 200,
      filter: false,
      valueGetter: (params: any) => {
        // Make sure AG Grid sees this number for filtering and sorting
        return params.data?.status === 3 ? params.data?.failed_count ?? 0 : 0;
      },
      cellRenderer: (params: ICellRendererParams) => {
        return params.data?.status === 3 ? (
          <Box display="flex" alignItems="center" gap={1}>
            {params.data?.failed_count >= 0 && (
              <img
                src={misconfig}
                alt="Misconfigurations"
                style={{ width: 20, height: 20 }}
              />
            )}
            <Typography title={String(params.data?.failed_count)}>
              {params.data?.failed_count}
            </Typography>
          </Box>
        ) : (
          <>0</>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    // {
    //   field: "region_name",
    //   headerName: "Regions",
    //   filter: true,
    //   showNist: false,
    //   minWidth: 180,
    //   width: 180,
    //   tooltipField: "region_name",
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },
  ];

  const fetchAssetsData = async (frameworkKeys: string[]) => {
    try {
      setIsLoading(true);
      const endpoint = END_POINTS.DEVICE_LIST_CLOUD;
      const payload = { type: 1, module: "cloud" };
      const response = await axiosInstance.post(endpoint, payload);
      if (response.data?.data) {
        const result = response.data?.data?.cloud_resource || [];
        const currentAssets = result.filter((item: any) => item.last_scan_status === true);
        const formattedData = currentAssets.map(
          (control: any) => ({
            cloud: control?.cloud,
            resource_name: control?.resource_name,
            resources_type: control?.resources_type,
            account_id: control?.account_id,
            region_name: control?.region_name,
            score: control?.score,
            status: control?.status,
            failed_count: control?.vulnerability_levels?.failed_count || 0,
            vendor: control?.cloud,
            total: control?.total,
            last_scanned: control?.last_scanned,
            vulnerability_levels: control?.vulnerability_levels,
            arn: control?.arn,
            region_id: control?.region_id,
            last_scan_status: control?.last_scan_status,
            criticality: control?.criticality,
            // Framework scores, only for frameworks switched on for the organization
            ...Object.fromEntries(
              frameworkKeys.map((key) => [key, control?.[key]])
            ),
          })
        );

        setIsResourceRowData(formattedData);
        // setIsReady(true);
      }
    } catch (error: any) {
      console.error("Error fetching assets data:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetsData(enabledFrameworkKeys);
  }, [enabledFrameworkKeys]);
  const navigate=useNavigate();

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            alignItems: "center",
          }}
        >
          {" "}
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", fontSize: "18px" }}
          >
            Cloud Resource
          </Typography>
          <LaunchSharpIcon
            sx={{
              color: isDarkMode ? "white" : "black",
              cursor: "pointer",
              fontSize: "20px",
            }}
            onClick={() => navigate("/cloud/cloud-resources")}
          ></LaunchSharpIcon>
        </div>
        <CancelIcon
          onClick={() => setDrawerOpen(false)}
          sx={{ cursor: "pointer" }}
        />
      </div>

      <AgGridTable
        columnDefs={ResourceColumnDefs}
        data={isResourceRowData}
        height={"calc(100vh - 92px)"}
        showSearch
        // headerActions={headerActions}
        // onRowClick={showDecommissioned ? undefined : handleScanRowClick}
        isLoading={isLoading}
        isRowSelectable={true}
        rowSelection="multiple"
        // onSelectionChange={handleSelectionChange}
        // gridOptions={gridOptions}
      />
    </div>
  );
};

export default ResourceCount;
